declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { SpinnerService } from '../../services/spinner.service';
import { AppData } from '../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HCPService } from '../../services/hcp.service';
import * as alertFunctions from '../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../shared/services/toastr.service';
import { ActorService } from '../../services/actor.service';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { FDService } from '../../services/fd.service';
import { ConsultantMapPipe } from '../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';
import { LabOrderTestsController, SaveSpecimenCollectionInfoRequest, SpecimenOrderTest } from '../../models/actor/actor';
import { ApiResponseModel } from '../../models/api_response_model';

@Component({
  selector: 'ngbspecimencollection',
  templateUrl: './specimencollection.modal.html',
  styleUrls: ['./specimencollection.modal.scss']
})

export class NgbSpecimenCollection implements OnInit {
  SelectedFromDate: NgbDateStruct;
  TodayDate = new Date();
  @Input() PatientName: string;
  @Input() Gender: string;
  @Input() Age: any;
  @Input() PatientFormttedCode: any;
  @Input() Phonenumber: string;
  @Input() OrderId: string;
  @Input() Branch: string;
  public isRequesting: boolean = false;
  @Input() OrderDate: Date;
  @Input() Tests: string;
  @Input() SelectedTests: LabOrderTestsController[];
  @Input() CurrentEditSaveSpecimenCollectionInfoRequest: SaveSpecimenCollectionInfoRequest;
  @Input() OrderCode: number;
  @Input() BranchCode: number;
  @Input() PatientCode: number;
  @Input() Specimen: string;
  @Input() Mode: string;
  public Age2: number;
  public ApiResData: ApiResponseModel;
  CurrentSaveSpecimenCollectionInfoRequest: SaveSpecimenCollectionInfoRequest;

  constructor(
    public activeModal: NgbActiveModal,
    private loaderService: SpinnerService,
    private actorservice: ActorService,
    private fdservice: FDService,
    private filter: ConsultantMapPipe,
    private parserFormatter: NgbDateParserFormatter,
    private router: Router,
    private route: ActivatedRoute,
    private hcpservice: HCPService,
    private modalService: NgbModal,
    private tosterservice: NGXToastrService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.CurrentSaveSpecimenCollectionInfoRequest = new SaveSpecimenCollectionInfoRequest();
    this.CurrentSaveSpecimenCollectionInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.Age2 = this.Age;
    if (this.Mode == 'Edit') {
      if (this.CurrentEditSaveSpecimenCollectionInfoRequest.CollectionDate != null) {
        var SValidFrom = new Date(this.CurrentEditSaveSpecimenCollectionInfoRequest.CollectionDate);
        if (SValidFrom.getFullYear() > 1900) {
          console.log('this.UpdateDate >1990');
          this.SelectedFromDate = {
            year: SValidFrom.getFullYear(),
            month: SValidFrom.getMonth() + 1,
            day: SValidFrom.getDate()
          }
        }
      }
    }
  }

  private getResultValue(res: any): number {
    if (res === null || res === undefined) return 0;
    if (typeof res === 'number') return res;
    if (typeof res === 'string') return parseInt(res, 10) || 0;
    if (Array.isArray(res) && res.length > 0) {
      const first = res[0];
      if (typeof first === 'number') return first;
      if (typeof first === 'object' && first !== null) {
        if ('Result' in first && typeof first.Result === 'number') return first.Result;
        if ('Result' in first && typeof first.Result === 'string') return parseInt(first.Result, 10) || 0;
        const keys = Object.keys(first);
        if (keys.length > 0 && typeof first[keys[0]] === 'number') return first[keys[0]];
      }
      return res.length;
    }
    return 0;
  }

  onSubmit2() {
    this.spinner.show();
    this.CurrentSaveSpecimenCollectionInfoRequest.OrderTestSpecimenCollectionCode = 0;
    this.CurrentSaveSpecimenCollectionInfoRequest.Tests = new Array<SpecimenOrderTest>();
    this.SelectedTests.forEach((v, i, a) => {
      var item: SpecimenOrderTest = new SpecimenOrderTest();
      item.TestName = v.TestName;
      item.TestSpecimenCode = v.TestSpecimenCode;
      item.OrderTestCode = v.OrderTestCode;
      this.CurrentSaveSpecimenCollectionInfoRequest.Tests.push(item);
    });

    this.CurrentSaveSpecimenCollectionInfoRequest.BranchCode = this.BranchCode;
    this.CurrentSaveSpecimenCollectionInfoRequest.OrderCode = this.OrderCode;
    this.CurrentSaveSpecimenCollectionInfoRequest.PatientCode = this.PatientCode;
    this.CurrentSaveSpecimenCollectionInfoRequest.Specimen = this.Specimen;
    this.CurrentSaveSpecimenCollectionInfoRequest.CollectionDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentSaveSpecimenCollectionInfoRequest.ConditionalOperator = 10;

    this.actorservice.SaveSpecimenCollectionInfo(this.CurrentSaveSpecimenCollectionInfoRequest)
      .subscribe(
        (result) => {
          this.ApiResData = result;
          const resVal = this.getResultValue(result ? result.Result : null);
          if (resVal > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.activeModal.close();
            this.stopRefreshing();
            this.spinner.hide();
          } else {
            alertFunctions.AlertParam("Invalid Operation :- " + "...!");
            this.stopRefreshing();
            this.spinner.hide();
          }
        },
        (error) => {
          alertFunctions.AlertParamEr(error);
          this.spinner.hide();
          this.stopRefreshing();
        }
      );
  }

  onSubmitEdit() {
    this.spinner.show();
    this.CurrentEditSaveSpecimenCollectionInfoRequest.BranchCode = this.BranchCode;
    this.CurrentEditSaveSpecimenCollectionInfoRequest.OrderCode = this.OrderCode;
    this.CurrentEditSaveSpecimenCollectionInfoRequest.PatientCode = this.PatientCode;
    this.CurrentEditSaveSpecimenCollectionInfoRequest.Specimen = this.Specimen;
    this.CurrentEditSaveSpecimenCollectionInfoRequest.ConditionalOperator = 20;

    this.actorservice.SaveSpecimenCollectionInfo(this.CurrentEditSaveSpecimenCollectionInfoRequest)
      .subscribe(
        (result) => {
          this.ApiResData = result;
          if (!this.ApiResData.hasError) {
            const resVal = this.getResultValue(result ? result.Result : null);
            if (resVal > 0) {
              this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
              this.spinner.hide();
              this.activeModal.close();
            } else {
              alertFunctions.AlertParam("Invalid Operation...!");
              this.spinner.hide();
            }
          } else {
            if (this.ApiResData.ErrorData && this.ApiResData.ErrorData != "") {
              alert(this.ApiResData.ErrorData);
            } else {
              this.spinner.hide();
              alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            }
          }
        },
        (error) => {
          alertFunctions.AlertParamEr(error);
          this.spinner.hide();
          this.stopRefreshing();
        }
      );
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }

  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
}
